var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Box, Button, Divider, InputAdornment, InputBase, MenuItem, Popover, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { useMutation } from "react-query";
import { GenderType } from "../../../models/profile/profile.model";
import { Allergy, COMMON_PREFERENCE_TYPES, DietType, MedicalCondition } from "../../../models/profile/preference.model";
import { ProfileService } from "../../../services/profile/profile.service";
import { convertLocalDateToDate, formatFullDMY } from "../../../utils/date.util";
import { useReadOnly } from "../../../utils/hooks/users/useReadOnly";
import { birthdayToAge, onlyCrqlarV2External } from "../../../utils/profile.util";
import { labelizeUnderScoreText, useLocalize } from "../../../utils/text.util";
import { getLanuageISO2Codes, getLocalizedLangLabel } from "../../../utils/translations.util";
import { AllergyElement, AllergyIcon } from "../../uiElements/AllergyElement";
import { LanguageChip, LanguageFlag } from "../../profileIdentity/ProfileLanguage";
import { normalizeLanguageCode, sameLanguage, uniqueLanguages } from "../../profileIdentity/profileLanguage.util";
import { DietElement, DietIcon } from "../../uiElements/DietElement";
import { MedicalElement, MedicalIcon } from "../../uiElements/MedicalElement";
import { AddButton, FieldRow, FieldRows, FLOATING_SHADOW, SidebarCard } from "./SidebarCard";
import { matchesSearch } from "../search";
var CRQLAR_FOOD_ALLERGY = COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_ALLERGY, CRQLAR_FOOD_TYPE = COMMON_PREFERENCE_TYPES.CRQLAR_FOOD_TYPE, CRQLAR_MEDICAL = COMMON_PREFERENCE_TYPES.CRQLAR_MEDICAL;
var OPTION_HEIGHT = 34;
var LIST_MAX_HEIGHT = 240;
var CUSTOM_VALUE_MAX_LENGTH = 40;
var COMMON_LANGUAGES = ['de', 'en', 'it', 'fr', 'nl'];
var SEARCH_LANGUAGES = ['en', 'de', 'it'];
// Imported questionnaire labels have no answer; hide them while preserving their stored values.
var HIDDEN_MEDICAL_VALUES = [
    'Fokus auf:',
    'Ziel der Behandlung',
    'Druck der Behandlung',
    'Nicht massieren:',
    'gesundheitl. Besonderheiten',
    'Unfälle/Operationen',
];
var isShownPreference = function (preference) {
    var _a, _b;
    return !(preference.preferenceType === CRQLAR_MEDICAL
        && HIDDEN_MEDICAL_VALUES.includes((_b = (_a = preference.preferenceValue) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : ''));
};
// Keep stored values removable even when they are excluded from the available options.
var getRowOptions = function (row, profile) {
    var _a;
    var cannotBePregnant = ((_a = profile.gender) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === GenderType.MALE
        || (!!profile.birthDay && birthdayToAge(profile.birthDay) < 18);
    return row.types[0] === CRQLAR_MEDICAL && cannotBePregnant
        ? row.options.filter(function (option) { return option !== MedicalCondition.PREGNANT; })
        : row.options;
};
var getPreferenceRows = function (t) { return [
    {
        label: t('Allergies'),
        types: [CRQLAR_FOOD_ALLERGY],
        options: Object.keys(Allergy),
        Element: AllergyElement,
        Icon: AllergyIcon,
    },
    {
        label: t('Diets'),
        types: [CRQLAR_FOOD_TYPE],
        options: Object.keys(DietType),
        Element: DietElement,
        Icon: DietIcon,
    },
    {
        label: t('Medical'),
        types: [CRQLAR_MEDICAL],
        options: Object.keys(MedicalCondition),
        Element: MedicalElement,
        Icon: MedicalIcon,
    },
]; };
var getLanguages = function (profile) { var _a; return uniqueLanguages(__spreadArray([profile.languageCode], ((_a = profile.additionalLanguages) !== null && _a !== void 0 ? _a : []), true)); };
var getGenderKey = function (gender) { return Object.keys(GenderType).find(function (key) { return key === (gender === null || gender === void 0 ? void 0 : gender.toUpperCase()); }); };
var SEARCH_ALIASES = {
    MILK: ['dairy', 'Milchprodukte', 'latticini'],
    TREE_NUTS: ['Haselnuss', 'Walnuss', 'Mandel', 'hazelnut', 'almond', 'nocciole'],
    PEANUTS: ['Erdnuss', 'arachide'],
    WHEAT: ['celiac', 'coeliac', 'Zöliakie', 'celiachia', 'frumento'],
    SHELLFISH: ['crustaceans', 'Krebstiere', 'shrimp', 'Garnelen', 'gamberi'],
    MOLLUSCS: ['mussels', 'Muscheln', 'squid', 'Tintenfisch', 'cozze'],
    SOYBEANS: ['soy', 'Soja'],
    SULPHITES: ['sulfites', 'Schwefel'],
    LACTOSE: ['lactose intolerance', 'Laktoseintoleranz', 'Milchzucker'],
    FRUCTOSE: ['Fruchtzucker'],
    PAPRIKA: ['bell pepper', 'Peperoni'],
    RAW_FRUIT: ['fresh fruit', 'Obst', 'Kreuzallergie'],
    CITRUS: ['orange', 'lemon', 'Orange', 'Zitrone', 'limone'],
    HISTAMINE: ['histamine intolerance', 'Histaminintoleranz'],
    FEATHERS: ['down', 'pillow', 'Kissen', 'Bettdecke', 'piumino'],
    ANIMAL_HAIR: ['pets', 'cats', 'Katzen', 'Hunde', 'gatti'],
    DUST_MITES: ['house dust', 'Hausstaub', 'Milben', 'polvere'],
    VEGETARIAN: ['veggie'],
    PESCATARIAN: ['pescetarian'],
    GLUTEN_FREE: ['celiac', 'coeliac', 'Zöliakie', 'celiachia'],
    LACTOSE_FREE: ['dairy free', 'milchfrei'],
    LOW_CARB: ['Kohlenhydrate', 'keto'],
    NO_ALCOHOL: ['alcohol free', 'alkoholfrei', 'analcolico'],
    NO_PORK: ['pork free', 'Schwein', 'maiale'],
    PREGNANT: ['pregnancy', 'Schwangerschaft', 'gravidanza'],
    DIABETES: ['diabetic', 'Diabetiker', 'Zucker'],
    HYPERTENSION: ['hypertension', 'Blutdruck', 'Hypertonie'],
    BACK_NECK: ['back pain', 'Rückenschmerzen', 'Bandscheibe'],
    ASTHMA: ['Asthmatiker'],
    MOBILITY: ['wheelchair', 'walker', 'Rollstuhl', 'Rollator', 'Gehhilfe', 'sedia a rotelle'],
    HEARING_SIGHT: ['deaf', 'blind', 'hearing aid', 'gehörlos', 'Hörgerät', 'sordo', 'cieco'],
    SURGERY: ['operation', 'injury', 'OP', 'Verletzung', 'infortunio'],
    CANCER: ['oncology', 'tumour', 'chemo', 'Onkologie', 'Tumor', 'tumore'],
};
var Picker = function (_a) {
    var options = _a.options, selected = _a.selected, _b = _a.locked, locked = _b === void 0 ? [] : _b, getOptionLabel = _a.getOptionLabel, getSearchTerms = _a.getSearchTerms, renderIcon = _a.renderIcon, freeSolo = _a.freeSolo, _c = _a.featured, featured = _c === void 0 ? [] : _c, onAdd = _a.onAdd, onRemove = _a.onRemove;
    var _d = useLocalize(), t = _d.t, language = _d.language;
    var _e = useState(null), anchorEl = _e[0], setAnchorEl = _e[1];
    var _f = useState(''), query = _f[0], setQuery = _f[1];
    var _g = useState(false), customOpen = _g[0], setCustomOpen = _g[1];
    var _h = useState(''), customValue = _h[0], setCustomValue = _h[1];
    var searchRef = useRef(null);
    var allOptions = __spreadArray(__spreadArray([], options, true), selected.filter(function (value) { return !options.includes(value); }), true);
    var search = query.trim().toLowerCase();
    var top = search ? [] : featured.filter(function (option) { return allOptions.includes(option); });
    var rest = allOptions
        .filter(function (option) {
        var _a;
        return !top.includes(option)
            && matchesSearch((_a = getSearchTerms === null || getSearchTerms === void 0 ? void 0 : getSearchTerms(option)) !== null && _a !== void 0 ? _a : [getOptionLabel(option)], search);
    })
        .sort(function (left, right) { return getOptionLabel(left).localeCompare(getOptionLabel(right), language); });
    var shown = __spreadArray(__spreadArray([], top, true), rest, true);
    var findOption = function (text) {
        return allOptions.find(function (option) { return getOptionLabel(option).toLowerCase() === text.trim().toLowerCase(); });
    };
    var canAddTyped = !!freeSolo && !!search && !findOption(search);
    var close = function () {
        setAnchorEl(null);
        setQuery('');
        setCustomOpen(false);
        setCustomValue('');
    };
    // One pick per opening: every choice closes the picker.
    var toggle = function (option) {
        if (selected.includes(option))
            onRemove(option);
        else
            onAdd(option);
        close();
    };
    // Text that matches a listed option adds that option, not a second spelling of it.
    var addCustom = function (text) {
        var trimmed = text.trim();
        if (!trimmed)
            return;
        var option = findOption(trimmed);
        if (!option)
            onAdd(trimmed);
        else if (!selected.includes(option))
            onAdd(option);
        close();
    };
    var rowSx = { gap: 1, minHeight: OPTION_HEIGHT, fontSize: 14 };
    var renderOption = function (option) { return (_jsxs(MenuItem, __assign({ dense: true, disabled: locked.includes(option), onClick: function () { return toggle(option); }, sx: rowSx }, { children: [renderIcon === null || renderIcon === void 0 ? void 0 : renderIcon(option), _jsx(Box, __assign({ component: "span", sx: { flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' } }, { children: getOptionLabel(option) })), selected.includes(option) && _jsx(CheckIcon, { sx: { fontSize: 16, color: 'primary.main' } })] }), option)); };
    return (_jsxs(_Fragment, { children: [_jsx(AddButton, { onClick: setAnchorEl }), _jsxs(Popover, __assign({ open: !!anchorEl, anchorEl: anchorEl, onClose: close, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, PaperProps: { variant: 'outlined', elevation: 0, sx: { boxShadow: FLOATING_SHADOW, width: 240, overflow: 'hidden' } }, 
                // Wait for the popover's focus handling before focusing the search field.
                TransitionProps: { onEntered: function () { var _a; return (_a = searchRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } } }, { children: [_jsx(InputBase, { inputRef: searchRef, fullWidth: true, value: query, placeholder: t('Search'), onChange: function (event) { return setQuery(event.target.value); }, onKeyDown: function (event) {
                            if (event.key !== 'Enter')
                                return;
                            event.preventDefault();
                            if (canAddTyped)
                                addCustom(query);
                            else if (shown[0] && !locked.includes(shown[0]))
                                toggle(shown[0]);
                        }, inputProps: { maxLength: CUSTOM_VALUE_MAX_LENGTH }, sx: { height: 40, px: 1.5, fontSize: 14 } }), _jsx(Divider, {}), _jsxs(Box, __assign({ sx: { maxHeight: LIST_MAX_HEIGHT, minHeight: freeSolo ? 56 : OPTION_HEIGHT + 8, overflowY: 'auto', py: 0.5 } }, { children: [freeSolo && (canAddTyped
                                ? (_jsxs(MenuItem, __assign({ dense: true, onClick: function () { return addCustom(query); }, sx: rowSx }, { children: [_jsx(AddIcon, { sx: { fontSize: 16, color: 'primary.main' } }), t('Add "{{value}}"', { value: query.trim() })] })))
                                : customOpen
                                    ? (_jsxs(Stack, __assign({ direction: 'row', gap: 1, sx: { px: 1, py: 0.5 } }, { children: [_jsx(TextField, { autoFocus: true, size: 'small', fullWidth: true, placeholder: t('Custom value'), value: customValue, inputProps: { maxLength: CUSTOM_VALUE_MAX_LENGTH }, onChange: function (event) { return setCustomValue(event.target.value); }, onKeyDown: function (event) {
                                                    if (event.key !== 'Enter')
                                                        return;
                                                    event.preventDefault();
                                                    addCustom(customValue);
                                                } }), _jsx(Button, __assign({ variant: 'contained', size: 'small', disabled: !customValue.trim(), onClick: function () { return addCustom(customValue); }, sx: { textTransform: 'none', flexShrink: 0 } }, { children: t('Add') }))] })))
                                    : (_jsxs(MenuItem, __assign({ dense: true, onClick: function () { return setCustomOpen(true); }, sx: __assign(__assign({}, rowSx), { color: 'primary.main', fontWeight: 600 }) }, { children: [_jsx(AddIcon, { sx: { fontSize: 16 } }), t('Add custom')] })))), top.map(renderOption), top.length > 0 && rest.length > 0 && _jsx(Divider, { sx: { my: 0.5 } }), rest.map(renderOption), shown.length === 0 && !freeSolo && (_jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary', sx: { px: 1.5, py: 1 } }, { children: t('No options') })))] }))] }))] }));
};
var PersonalCard = function (_a) {
    var profile = _a.profile, setProfile = _a.setProfile, voiceNoteId = _a.voiceNoteId;
    var _b = useLocalize(), t = _b.t, tFallback = _b.tFallback, i18n = _b.i18n, locale = _b.language;
    var readOnly = useReadOnly();
    var _c = useState(), draft = _c[0], setDraft = _c[1];
    var preferenceRows = getPreferenceRows(t);
    var editedTypes = preferenceRows.flatMap(function (row) { return row.types; });
    // A PMS owns these fields: the next push would overwrite an edit made here.
    var managedExternally = !!profile.primaryProvider && !onlyCrqlarV2External(profile);
    var getPreferenceKey = function (type, value) {
        return type === CRQLAR_MEDICAL ? "Common health preference value ".concat(value) : "".concat(type, "_").concat(value);
    };
    var getPreferenceLabel = function (type, value) {
        return tFallback(getPreferenceKey(type, value), labelizeUnderScoreText(value));
    };
    var getPreferenceSearchTerms = function (type, value) {
        var _a;
        return __spreadArray(__spreadArray([
            getPreferenceLabel(type, value)
        ], SEARCH_LANGUAGES.map(function (lng) { return i18n.t(getPreferenceKey(type, value), { lng: lng, defaultValue: '' }); }), true), ((_a = SEARCH_ALIASES[value]) !== null && _a !== void 0 ? _a : []), true).filter(Boolean);
    };
    // Merge this form's fields into the latest profile, preserving edits made elsewhere while it was open.
    var saveMut = useMutation(function (edited) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, ProfileService.updateProfile(__assign(__assign({}, profile), { birthDay: edited.birthDay, gender: edited.gender, languageCode: edited.languageCode, additionalLanguages: edited.additionalLanguages, preferences: __spreadArray(__spreadArray([], ((_a = profile.preferences) !== null && _a !== void 0 ? _a : []).filter(function (preference) { return !editedTypes.includes(preference.preferenceType); }), true), ((_b = edited.preferences) !== null && _b !== void 0 ? _b : []).filter(function (preference) { return editedTypes.includes(preference.preferenceType); }), true) }))];
                case 1:
                    response = _c.sent();
                    setProfile(response);
                    setDraft(undefined);
                    return [2 /*return*/];
            }
        });
    }); });
    // One chip per value, alphabetical: PMS and voice notes can store the same value twice.
    var getPreferenceItems = function (source, row) {
        var _a;
        var preferences = ((_a = source.preferences) !== null && _a !== void 0 ? _a : [])
            .filter(function (preference) { return !!preference.preferenceValue && row.types.includes(preference.preferenceType); })
            .filter(isShownPreference);
        return preferences
            .filter(function (preference, index) { return preferences.findIndex(function (other) { return other.preferenceValue === preference.preferenceValue; }) === index; })
            .map(function (preference) {
            var _a;
            return ({
                preference: preference,
                label: getPreferenceLabel((_a = preference.preferenceType) !== null && _a !== void 0 ? _a : row.types[0], preference.preferenceValue),
                active: !!voiceNoteId && preferences.some(function (other) {
                    return other.preferenceValue === preference.preferenceValue && other.voiceNoteId === voiceNoteId;
                })
            });
        })
            .sort(function (left, right) { return left.label.localeCompare(right.label, locale); });
    };
    var addLanguage = function (code) { return setDraft(function (current) {
        var _a, _b;
        if (!current || getLanguages(current).some(function (language) { return sameLanguage(language, code); }))
            return current;
        return ((_a = current.languageCode) === null || _a === void 0 ? void 0 : _a.trim())
            ? __assign(__assign({}, current), { additionalLanguages: __spreadArray(__spreadArray([], ((_b = current.additionalLanguages) !== null && _b !== void 0 ? _b : []), true), [code], false) }) : __assign(__assign({}, current), { languageCode: code });
    }); };
    var removeLanguage = function (code) { return setDraft(function (current) {
        if (!current)
            return current;
        var rest = getLanguages(current).filter(function (language) { return !sameLanguage(language, code); });
        return sameLanguage(current.languageCode, code)
            ? __assign(__assign({}, current), { languageCode: rest[0], additionalLanguages: rest.slice(1) }) : __assign(__assign({}, current), { additionalLanguages: rest.filter(function (language) { return !sameLanguage(language, current.languageCode); }) });
    }); };
    var addPreference = function (preferenceType, preferenceValue) { return setDraft(function (current) {
        var _a, _b;
        if (!current)
            return current;
        var exists = (_a = current.preferences) === null || _a === void 0 ? void 0 : _a.some(function (preference) {
            return preference.preferenceType === preferenceType && preference.preferenceValue === preferenceValue;
        });
        return exists ? current : __assign(__assign({}, current), { preferences: __spreadArray(__spreadArray([], ((_b = current.preferences) !== null && _b !== void 0 ? _b : []), true), [{ preferenceType: preferenceType, preferenceValue: preferenceValue }], false) });
    }); };
    var removePreference = function (toRemove) { return setDraft(function (current) {
        var _a;
        return current && (__assign(__assign({}, current), { preferences: ((_a = current.preferences) !== null && _a !== void 0 ? _a : []).filter(function (preference) {
                return !(preference.preferenceType === toRemove.preferenceType && preference.preferenceValue === toRemove.preferenceValue);
            }) }));
    }); };
    var removePreferenceValue = function (types, value) { return setDraft(function (current) {
        var _a;
        return current && (__assign(__assign({}, current), { preferences: ((_a = current.preferences) !== null && _a !== void 0 ? _a : []).filter(function (preference) {
                return !(types.includes(preference.preferenceType) && preference.preferenceValue === value);
            }) }));
    }); };
    var renderLockedField = function (value) { return (_jsx(TextField, { size: 'small', fullWidth: true, disabled: true, value: value, InputProps: {
            endAdornment: (_jsx(InputAdornment, __assign({ position: 'end' }, { children: _jsx(Tooltip, __assign({ title: t('Comes from the PMS'), arrow: true }, { children: _jsx(LockOutlinedIcon, { sx: { fontSize: 18, color: 'text.secondary', pointerEvents: 'auto' } }) })) })))
        } })); };
    var viewBirthday = convertLocalDateToDate(profile.birthDay);
    var viewLanguages = getLanguages(profile);
    var viewPreferenceRows = preferenceRows
        .map(function (row) { return ({ row: row, items: getPreferenceItems(profile, row) }); })
        .filter(function (_a) {
        var items = _a.items;
        return items.length > 0;
    });
    var isEmpty = !viewBirthday && viewLanguages.length === 0 && viewPreferenceRows.length === 0;
    // An empty card is still the only place staff without CRM access can add a language
    // (it drives the table-plan flag), so only read-only users lose it.
    if (isEmpty && readOnly) {
        return null;
    }
    var renderEditForm = function (edited) {
        var _a;
        var editedLanguages = getLanguages(edited);
        var genderKey = getGenderKey(edited.gender);
        return (_jsxs(FieldRows, { children: [_jsx(FieldRow, __assign({ label: t('Birthday') }, { children: managedExternally
                        ? renderLockedField(formatFullDMY(convertLocalDateToDate(edited.birthDay)) || t('(Not set)'))
                        : (_jsx(TextField, { type: 'date', size: 'small', fullWidth: true, value: (_a = edited.birthDay) !== null && _a !== void 0 ? _a : '', onChange: function (event) { return setDraft(__assign(__assign({}, edited), { birthDay: event.target.value || undefined })); } })) })), _jsx(FieldRow, __assign({ label: t('Gender') }, { children: managedExternally
                        ? renderLockedField(genderKey ? t("Gender type ".concat(genderKey)) : t('(Not set)'))
                        : (_jsxs(TextField, __assign({ select: true, size: 'small', fullWidth: true, value: genderKey !== null && genderKey !== void 0 ? genderKey : '', onChange: function (event) { return setDraft(__assign(__assign({}, edited), { gender: event.target.value || undefined })); }, SelectProps: { displayEmpty: true } }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: t('(Not set)') })), Object.keys(GenderType).map(function (gender) { return (_jsx(MenuItem, __assign({ value: gender }, { children: t("Gender type ".concat(gender)) }), gender)); })] }))) })), _jsxs(FieldRow, __assign({ label: t('Language') }, { children: [editedLanguages.map(function (code) { return (_jsx(LanguageChip, { code: code, locale: locale, onDelete: managedExternally && sameLanguage(code, edited.languageCode)
                                ? undefined
                                : function () { return removeLanguage(code); } }, code.toLowerCase())); }), _jsx(Picker, { options: getLanuageISO2Codes(), selected: editedLanguages.map(normalizeLanguageCode), locked: managedExternally && edited.languageCode ? [normalizeLanguageCode(edited.languageCode)] : [], getOptionLabel: function (code) { return getLocalizedLangLabel(code, locale) || code; }, renderIcon: function (code) { return _jsx(LanguageFlag, { code: code }); }, featured: COMMON_LANGUAGES, onAdd: addLanguage, onRemove: removeLanguage })] })), preferenceRows.map(function (row) {
                    var items = getPreferenceItems(edited, row);
                    return (_jsxs(FieldRow, __assign({ label: row.label }, { children: [items.map(function (_a) {
                                var preference = _a.preference, label = _a.label;
                                return (_jsx(row.Element, { label: label, value: preference.preferenceValue, onDelete: function () { return removePreference(preference); } }, "".concat(preference.preferenceType, "-").concat(preference.preferenceValue)));
                            }), _jsx(Picker, { options: getRowOptions(row, edited), selected: items.map(function (item) { return item.preference.preferenceValue; }), getOptionLabel: function (option) { return getPreferenceLabel(row.types[0], option); }, getSearchTerms: function (option) { return getPreferenceSearchTerms(row.types[0], option); }, renderIcon: function (option) { return _jsx(row.Icon, { value: option }); }, freeSolo: true, onAdd: function (value) { return addPreference(row.types[0], value); }, onRemove: function (value) { return removePreferenceValue(row.types, value); } })] }), row.label));
                })] }));
    };
    return (_jsx(SidebarCard, __assign({ title: t('Personal'), onEdit: readOnly ? undefined : function () { return setDraft(profile); }, editContent: draft && renderEditForm(draft), saving: saveMut.isLoading, onCancel: function () { return setDraft(undefined); }, onSave: function () { return draft && saveMut.mutate(draft); } }, { children: _jsxs(FieldRows, { children: [isEmpty && (_jsx(Typography, __assign({ variant: 'body2', color: 'text.secondary' }, { children: t('(Not set)') }))), viewBirthday && (_jsx(FieldRow, __assign({ label: t('Birthday') }, { children: "".concat(formatFullDMY(viewBirthday), " (").concat(birthdayToAge(profile.birthDay), ")") }))), viewLanguages.length > 0 && (_jsx(FieldRow, __assign({ label: t('Language') }, { children: viewLanguages.map(function (code) { return (_jsx(LanguageChip, { code: code, locale: locale }, code.toLowerCase())); }) }))), viewPreferenceRows.map(function (_a) {
                    var row = _a.row, items = _a.items;
                    return (_jsx(FieldRow, __assign({ label: row.label }, { children: items.map(function (_a) {
                            var preference = _a.preference, label = _a.label, active = _a.active;
                            return (_jsx(row.Element, { label: label, value: preference.preferenceValue, active: active }, "".concat(preference.preferenceType, "-").concat(preference.preferenceValue)));
                        }) }), row.label));
                })] }) })));
};
export default PersonalCard;
